import React from 'react'
import {
    BrowserRouter,
    Routes,
    Route,
} from "react-router-dom";
import AddPhysio from '../pages/addPhysio/AddPhysio';
import Clients from '../pages/clients/Clients';
import Home from '../pages/home/Home';
import CenterEmailLogin from '../pages/login/CenterLoginEmail';
import CenterPwd from '../pages/login/CenterPwd';
import Login from '../pages/login/Login';
import Privacy from '../pages/privacy/Privacy';
import SurveyDetails from '../pages/surveys/SurveyDetails';
import Surveys from '../pages/surveys/Surveys';
import Therapists from '../pages/therapists/Therapists';
const AppRouter = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/add_physio" element={<AddPhysio />} />
                <Route path="/login" element={<CenterEmailLogin />} />
                <Route path="/pwd" element={<CenterPwd />} />
                <Route path="/admin" element={<Login />} />
                <Route path="/therapists" element={<Therapists />} />
                <Route path="/clients" element={<Clients />} />
                <Route path="/surveys" element={<Surveys />} />
                <Route path="/survey_details" element={<SurveyDetails />} />
                <Route path="/privacy" element={<Privacy />} />
            </Routes>
        </BrowserRouter>
    )
}

export default AppRouter